import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

function renderKatex(latex, displayMode = false) {
  try {
    return katex.renderToString(latex, {
      throwOnError: false,
      displayMode,
      strict: 'ignore',
      trust: false,
      output: 'html',
    });
  } catch {
    return `<code>${latex}</code>`;
  }
}

/** 轻量文本中的 $...$ / $$...$$ 公式渲染。 */
export function MathText({ text, className = '' }) {
  if (!text) return null;
  const source = String(text);
  const tokens = source.split(/(\$\$[^$]+\$\$|\$[^$]+\$)/g).filter(Boolean);
  return (
    <span className={className}>
      {tokens.map((token, index) => {
        if (token.startsWith('$$') && token.endsWith('$$') && token.length > 4) {
          return (
            <span
              key={`${token}-${index}`}
              className="math-block"
              dangerouslySetInnerHTML={{ __html: renderKatex(token.slice(2, -2), true) }}
            />
          );
        }
        if (token.startsWith('$') && token.endsWith('$') && token.length > 2) {
          return (
            <span
              key={`${token}-${index}`}
              className="math-inline"
              dangerouslySetInnerHTML={{ __html: renderKatex(token.slice(1, -1), false) }}
            />
          );
        }
        return <React.Fragment key={`text-${index}`}>{token}</React.Fragment>;
      })}
    </span>
  );
}

export function MathBlock({ latex }) {
  if (!latex) return null;
  return (
    <div
      className="math-block-card"
      dangerouslySetInnerHTML={{ __html: renderKatex(latex, true) }}
    />
  );
}
